import { z } from 'zod';
import {
  MembrosResponseSchema,
  MinhasEmpresasResponseSchema,
  type ConvidarMembro,
  type AceitarConvite,
  type MembrosResponse,
  type MinhasEmpresasResponse,
  type Papel,
} from '@lance-x/shared';
import type { ApiClient } from '../index';

const SwitchResponseSchema = z.object({ accessToken: z.string() });
const ConviteCreatedSchema = z.object({
  id: z.string(),
  email: z.string(),
  papel: z.enum(['ADMINISTRADOR', 'COLABORADOR', 'VISUALIZADOR']),
  expiresAt: z.string(),
});

export class TeamEndpoints {
  constructor(private readonly client: ApiClient) {}

  convidar(input: ConvidarMembro) {
    return this.client.post('/empresa/convites', input, {
      responseSchema: ConviteCreatedSchema,
    });
  }

  aceitarConvite(input: AceitarConvite) {
    return this.client.post('/convites/aceitar', input, {
      responseSchema: SwitchResponseSchema,
    });
  }

  listarMembros(): Promise<MembrosResponse> {
    return this.client.get('/empresa/membros', {
      responseSchema: MembrosResponseSchema,
    });
  }

  editarPapel(membroId: string, papel: Papel) {
    return this.client.patch(`/empresa/membros/${membroId}`, { papel });
  }

  removerMembro(membroId: string) {
    return this.client.delete(`/empresa/membros/${membroId}`);
  }

  reenviarConvite(conviteId: string) {
    return this.client.post(`/empresa/convites/${conviteId}/reenviar`, undefined);
  }

  minhasEmpresas(): Promise<MinhasEmpresasResponse> {
    return this.client.get('/me/empresas', {
      responseSchema: MinhasEmpresasResponseSchema,
    });
  }

  switchEmpresa(empresaId: string) {
    return this.client.post('/me/empresas/switch', { empresaId }, {
      responseSchema: SwitchResponseSchema,
    });
  }
}
